import styled from 'styled-components';

import { getThemeProp } from 'theme';

export const SContainer = styled.header`
  align-items: center;
  background-color: ${getThemeProp('colors.eastBayBlue')};
  display: flex;
  height: ${getThemeProp('header.height')};
  justify-content: space-between;
`;

export const SLeftPart = styled.div`
  flex: 1;
  text-align: left;
`;

export const SRightPart = styled.div`
  flex: 1;
`;

export const SCenterPart = styled.div`
  flex: 1;
  text-align: center;
`;

export const SStudioLogo = styled.img.attrs(() => ({
  src: require('styles/images/Logo-Conversation-Studio-big.svg'),
  alt: 'Conversation Studio logo',
}))`
  padding-left: 18px;
`;

export const SRightContent = styled.div`
  display: flex;
  justify-content: flex-end;
`;
